import { ClientDataService, IClientDataDoc } from '../../../services/clientData.service'

export class CrewService extends ClientDataService {
  private CREW_LIST_DOC = 'serviceusers'
  private CLINICAL_CREW_LIST_DOC = 'clinicalusers'
  private BASE_OPTIONS_DOC = 'bases'
  private STAFFING_LEVEL_OPTIONS_DOC = 'tb_unit_staffing'
  private SHIFT_OPTIONS_DOC = 'tb_prshift'
  private VEHICLE_OPTIONS_DOC = 'units'
  private REGISTRATION_TAIL_OPTIONS_DOC = 'tb_unit_tail'
  private PRIMARY_MONITOR_OPTIONS_DOC = 'cloudekg_datefilter-custom'
  private ROLE_OPTIONS_DOC = 'tb_nhtsa_crewrole'
  private PRECEPTOR_STUDENT_OPTIONS_DOC = 'tb_preceptor_student-custom'
  private UNIT_EQUIPMENT_OPTIONS_DOC = 'tb_unit_capability'
  private CREW_STATE_LICENSURES_DOC = 'tb_crew_licensures_data-custom'
  private CREW_NATIONAL_LICENSURES_DOC = 'tb_crew_licensures_data_national-custom'
  private CLINICAL_USER_LIST = 'tb_clinical_user'

  async getCrewList(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CREW_LIST_DOC)
  }

  async getClinicalCrewList(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CLINICAL_CREW_LIST_DOC)
  }

  async getBaseOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.BASE_OPTIONS_DOC)
  }

  async getStaffingLevelOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.STAFFING_LEVEL_OPTIONS_DOC)
  }

  async getShiftOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SHIFT_OPTIONS_DOC)
  }

  async getVehicleOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.VEHICLE_OPTIONS_DOC)
  }

  async getRegistrationTailOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.REGISTRATION_TAIL_OPTIONS_DOC)
  }

  async getUnitEquipmentOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.UNIT_EQUIPMENT_OPTIONS_DOC)
  }

  async getPrimaryMonitorOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PRIMARY_MONITOR_OPTIONS_DOC)
  }

  async getRoleOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.ROLE_OPTIONS_DOC)
  }

  async getPreceptorStudentOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PRECEPTOR_STUDENT_OPTIONS_DOC)
  }

  async getCrewStateLicensures(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CREW_STATE_LICENSURES_DOC)
  }

  async getCrewNationalLicensures(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CREW_NATIONAL_LICENSURES_DOC)
  }

  async getClinicalUserList(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CLINICAL_USER_LIST)
  }
}
